import React, { ReactNode, SyntheticEvent, useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Draggable from 'react-draggable';
import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import PhotoSizeSelectSmallOutlinedIcon from '@mui/icons-material/PhotoSizeSelectSmallOutlined';
import LineAxisOutlinedIcon from '@mui/icons-material/LineAxisOutlined';
import { Divider, ListItemIcon, ListItemText, MenuItem, MenuList, Stack } from '@mui/material';
import { SurfaceType } from "@/utils/builder/builderConstants";
import ClientComponent from './client_component';


function ContextualMenu(props: {
  show: boolean,
  dimensionsEnabled: boolean,
  axisEnabled: boolean,
  deleteProductCallback: () => {},
  toggleDimensionsModeCallback: () => {}
  toggleAxisCallback: (toggle: boolean) => {}
  dragStartCallback: () => {},
  dragEndCallback: () => {}
}) {
  const [panelPosition, setPanelPosition] = useState({ x: window.innerWidth - 550, y: window.innerHeight - 60 });
  const positionUpdated = useRef(false);


  const handleDragStop = (event: any, { x, y }: { x: number, y: number }) => {
    props.dragEndCallback();
    positionUpdated.current = true;
    setPanelPosition({ x, y });
  }

  const handleDragStart = () => {
    console.log('drag start....');
    props.dragStartCallback();
  }

  return (
    <Draggable
      //defaultPosition={panelPosition}
      //position={panelPosition}
      onStart={handleDragStart}
      onStop={handleDragStop}
      handle='.panel-drag-handle'
    >
      <Box component={'div'}
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          //bgcolor: 'background.paper',
          display: 'flex',
          zIndex: 999,
          borderRadius: '8px'
        }}
        visibility={props.show ? 'visible' : 'hidden'}
      >
        <Stack spacing={0} direction="row">
          <Box component={'div'}
            sx={{ height: 40 }}
          >
            <MenuList
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                p: 0,
                m: 0,
                bgColor: 'gray',
                borderRadius: 1,
                height: '40px',
                backgroundColor: 'white'
              }}>
              {/* <MenuItem
                sx={{
                  width: '0px'
                }}
              >
                <Box component={'div'} className="panel-drag-handle">
                  <DragIndicatorIcon fontSize="large" color="secondary" />
                </Box>
              </MenuItem> */}
              <MenuItem
                onClick={() => props.deleteProductCallback()}
                sx={{
                  width: '40px'
                }}
              >
                <Stack>
                  <ListItemIcon>
                    <DeleteIcon fontSize="large" color='secondary' />
                  </ListItemIcon>
                  {/* <ListItemText primaryTypographyProps={{ color: 'white' }}>
                    Delete
                  </ListItemText> */}
                </Stack>
              </MenuItem>
              <MenuItem
                onClick={() => props.toggleDimensionsModeCallback()}
                sx={{
                  width: '40px'
                }}
              >
                <ListItemIcon>
                  <PhotoSizeSelectSmallOutlinedIcon fontSize="large" color={props.dimensionsEnabled ? 'primary' : 'secondary'} />
                </ListItemIcon>
              </MenuItem>
              <MenuItem
                onClick={() => props.toggleAxisCallback(!props.axisEnabled)}
                sx={{
                  width: '40px'
                }}
              >
                <ListItemIcon>
                  <LineAxisOutlinedIcon fontSize="large" color={props.axisEnabled ? 'primary' : 'secondary'} />
                </ListItemIcon>
              </MenuItem>
            </MenuList>
          </Box>
        </Stack>
      </Box>
    </Draggable >
  );
}
export default ClientComponent(ContextualMenu);